var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "url(#pattern)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1214_65",
    transform: "matrix(0.0384615 0 0 0.0512821 0 -0.0128205)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1214_65",
    width: 26,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAUCAYAAACTQC2+AAABQ2lDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSCwoyGFhYGDIzSspCnJ3UoiIjFJgf87AxcDPIMSgwaCQmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsisr4U7F0w247laHx9U+H1qISemehTAlZJanAyk/wBxUnJBUQkDA2MCkK1cXlIAYrcA2SJFQEcB2TNA7HQIew2InQRhHwCrCQlyBrKvANkCyRmJKUD2EyBbJwlJPB2JDbUXBDhCjSxcTS0NCDiVdFCSWlECop3zCyqLMtMzShQcgSGUquCZl6yno2BkYGTMwAAKb4jqz2LgcGQUO4UQy37EwGBpzcDA9BkhlhDKwLA1hoGBVxshpjWfgUEwk4HhMH9BYlEi3AGM31iK04yNIGyeIgYG1h///3+WZWBg38XA8Lfo///fc////7uEgYH5JgPDgUIAdGNdtScTytEAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAABqgAwAEAAAAAQAAABQAAAAA0DEqUQAAAK9JREFUSA3tlWEOQDAMhTsncxQHMFfAHRzIzWqvsYUQaWNN/NBkSLb6+rY+AnlH5A6I4MoZeCSmyRd0gCTY7CMIkMgso2dRVB/0Q0x7+q3tgqF2U5lUYLFJSW5DJFnCBCFqipngYC0M63bHS/4SJl2NMJVWmVHJtQAN7DUkY59g1SBPsAqQ+98ElAXKXbimGlqpA19h9cFLRrncgzB9hpGtu8r7lQ/5zHB3j57bGowNC8S9K0kCkGEAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon-tick.929712a185da6ee558889e05c1cc54bc.svg";
export { ForwardRef as ReactComponent };